import { createStore } from 'vuex'
import _ from 'lodash'
import api from '../api'
import builder from './modules/builder'
import assets from './modules/assets'

export default createStore({
  modules: { builder, assets },
  state: {
    user: null,
    clients: { },
    apiToken: null,
    csrfToken: null,
    cancelToken: null,
    favorites: [],
    recentlyViewed: []
  },
  getters: {
    isAdmin: ({ user }) => _.get(user, 'is_admin', false),
    projects: ({ clients }) => _.flatMap(clients, 'projects'),
    savedProjects: ({ favorites }, { projects }) => _.map(favorites, (id) => _.find(projects, { id })),
    recentProjects ({ recentlyViewed }, { projects }) {
      return _.reduce(recentlyViewed, (result, id) => {
        const project = _.find(projects, { id })
        if (project) {
          result.push(project)
        }
        return result
      }, [])
    }
  },
  mutations: {
    setUser (state, value) {
      state.user = value
    },
    setClients (state, value) {
      state.clients = value
    },
    setFavorites (state, value) {
      state.favorites = value
    },
    setRecentlyViewed (state, value) {
      state.recentlyViewed = value
    },
    addFavorite (state, value) {
      state.favorites.push(value)
    },
    removeFavorite (state, value) {
      const index = state.favorites.indexOf(value)
      if (index >= 0) {
        state.favorites.splice(index, 1)
      }
    },
    setCsrfToken (state, value) {
      state.csrfToken = value
    },
    setApiToken (state, value) {
      state.apiToken = value
    },
    setCancelToken (state, value) {
      state.cancelToken = value
    }
  },
  actions: {
    initialize ({ commit }, payload) {
      if (payload.user) {
        commit('setUser', payload.user)
      }
      if (payload.clients) {
        commit('setClients', payload.clients)
      }
      if (payload.favorites) {
        commit('setFavorites', payload.favorites)
      }
      if (payload.recentlyViewed) {
        commit('setRecentlyViewed', payload.recentlyViewed)
      }

      api.setup(this)
    },
    async toggleFavorite ({ state, commit }, id) {
      const value = state.favorites.indexOf(id) >= 0
      const toggle = value ? 0 : 1
      toggle ? commit('addFavorite', id) : commit('removeFavorite', id)
      const result = await api.toggleFavorite(id, toggle)

      // reset value
      if (!result) {
        toggle ? commit('removeFavorite', id) : commit('addFavorite', id)
      }
    },
    async refreshCsrfToken ({ commit }) {
      const result = await api.getCsrfToken()
      if (result) {
        commit('setCsrfToken', result)
      }
    }
  }
})